/**
 * PBKDF2-SHA256 password hashing for the employee time portal.
 *
 * The OWNER sets an employee's portal password from the Edit Employee modal;
 * we hash it client-side here (the owner is trusted — this is their own data)
 * and store only the hash on the employee row. The employee-portal Edge
 * Function verifies logins against the same format server-side:
 *   pbkdf2$<iterations>$<saltB64>$<hashB64>
 * Keep this format in lockstep with supabase/functions/employee-portal.
 */
const ITERATIONS = 100_000;

function b64(buf: ArrayBuffer): string {
  return btoa(String.fromCharCode(...new Uint8Array(buf)));
}

export async function hashPortalPassword(password: string): Promise<string> {
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const key = await crypto.subtle.importKey(
    "raw", new TextEncoder().encode(password), "PBKDF2", false, ["deriveBits"],
  );
  const bits = await crypto.subtle.deriveBits(
    { name: "PBKDF2", hash: "SHA-256", salt, iterations: ITERATIONS },
    key, 256,
  );
  return `pbkdf2$${ITERATIONS}$${b64(salt.buffer)}$${b64(bits)}`;
}
